module.exports = __webpack_public_path__ + "img/chu_ky_vimo_tl.f2bd5f5e.jpg";